import {ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ConfirmationDialogComponent implements OnInit {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            title: string,
            cancelText: string,
            submitText: string,
            text?: string,
        },
        public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    ) {
    }

    ngOnInit(): void {
    }

    /** Close dialog */
    closeDialog(result: boolean) {
        this.dialogRef.close(result);
    }

}
